var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header with-cover mb-4"},[_c('div',{staticClass:"page-cover",style:(_vm.coverBg)}),_c('div',{staticClass:"header-content px-2",domProps:{"innerHTML":_vm._s(_vm.headerContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }